import { Notifications } from "widgets/notifications"

export const NotificationsPage = () => {
  return <Notifications />
}